import getInitiativeTypes from './getInitiativeTypes';

export default (type) => getInitiativeTypes().find(({ value }) => value === type)?.label;
